// api/ragChat.js
import {fetchWithAuth} from "../utils/fetchWithAuth";

export async function askRagChatStream(question, onChunk) {
  const token = localStorage.getItem('token');
  const anonId = localStorage.getItem('anon_id');
  const response = await fetchWithAuth(`/rag-chat`, {
    method: "POST",
    headers: {
      "X-Anonymous-ID": !token && anonId ? anonId : ""
    },
    body: JSON.stringify({ question }),
  });

  if (response.status === 429) {
    throw new Error("429: Too many requests");
  }

  if (!response.ok) {
    throw new Error(`서버 오류: ${response.status}`);
  }

  if (!response.body) {
    throw new Error("No response body for stream");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let partial = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    const chunk = decoder.decode(value, { stream: true });
    partial += chunk;
    onChunk(partial); // 누적된 전체 텍스트 전달
  }

  return partial;
}
